import {useTranslation} from 'react-i18next';
import {List} from '@tickchak/react-share/app';
import Ex from '../../../assets/icons/ex';
import Headphones from '../../../assets/icons/headphones';
import {SupportVideosFooterProps} from './SupportVideos.type';

function SupportVideosFooter({onClose, onContactSupport}: SupportVideosFooterProps) {
    const {t} = useTranslation('layout');

    return (<List.Footer fixed>
                <List.Footer.Close
                    text={t('closeIt')}
                    onClick={onClose}
                    iconStart={<Ex />}
                    size='category'
                />
                <List.Footer.Button
                    text={t('contactSupport')}
                    onClick={onContactSupport}
                    iconStart={<Headphones />}
                    variant='brand'
                    size='category'
                />
            </List.Footer>
    );
}

export default SupportVideosFooter;
